module.exports = __webpack_public_path__ + "img/fantasy-logo.ac50643b.png";